export const isNullOrEmptyOrUndefined = (value) =>
  value === undefined || value === null || value === '';

export const generatePassByEmail = (email) => {
    return Buffer.from(email).toString('base64')
}